import {
  AccordionDetails as MuiAccordionDetails,
  AccordionDetailsProps as MuiAccordionDetailsProps,
  accordionDetailsClasses,
} from '@mui/material'
import styled from 'styled-components'

export { accordionDetailsClasses }
export type AccordionDetailsPropsType = MuiAccordionDetailsProps

const AccordionDetails = styled(MuiAccordionDetails)<AccordionDetailsPropsType>``

export default AccordionDetails
